import React, { useState, useEffect } from "react";
import { ApiService } from "../../utils/ApiService";
import Pagination from "../../common/Pagination";
import SearchComponent from "../../components/SearchComponent";
import { Avatar, formatDateTime } from "../../common/Functions";
import { showToast } from "../../common/Toast";
import FullPageLoader from "../../common/FullPageLoader";
import { capitalizeEachWord } from "../../utils/common";

const Attendees = () => {

  const [attendeeData, setAttendeeData] = useState([]);
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [pagination, setPagination] = useState({});
  const [loading, setloading] = useState(false);

  const fetchAttendeeData = async (currentPage, currentLimit, search) => {
    const params = {
      userRole: "ATTENDEE",
      page: currentPage,
      limit: currentLimit,
    };
    if (search?.trim()) {
      params.keyword = search;
    }
    try {
      setloading(true);
      const queryString = new URLSearchParams(params).toString();

      const res = await ApiService.get(`admin/user-list?${queryString}`);

      if (res.success) {
        setAttendeeData(res.user || []);
        setPagination(res.pagination);
      }
    } catch (error) {
      console.log("host error", error);
    } finally {
      setloading(false);
    }
  };

  useEffect(() => {
    fetchAttendeeData(page, limit);
  }, []);

  const handleStatus = async (id, status) => {
    try {
      let params = {
        userId: id,
        status: !status,
      };
      const res = await ApiService.post(`admin/enable-disable-user`, params);
      console.log(res);
      if (res.success) {
        showToast.success(res.message);
        fetchAttendeeData(page, limit);
      } else {
        showToast.error(res.message);
      }
    } catch (error) {}
    // setHostData((prev) =>
    //   prev.map((x) => (x.id === id ? { ...x, active: !x.active } : x))
    // );
  };

  const handlePagination = (newPage) => {
    if (newPage >= 1 && newPage <= pagination.totalPages) {
      setPage(newPage);
      fetchAttendeeData(newPage, limit, search);
    }
  };

  const handleSearch = (e) => {
    const value = e.target.value;
    if (value.startsWith(" ")) return;
    setSearch(value);
    setPage(1);
    fetchAttendeeData(1, limit, e.target.value);
  };
  const startingIndex = (page - 1) * limit;

  return (
    <>
    {loading && <FullPageLoader/>}
      <div className="flex-grow bg-gray-100  px-6 pb-2 w-full overflow-auto h-[90vh]">
        <div className="w-full">
          {/* Search + Right Badge */}
          <div className="mb-6">
            <SearchComponent
              search={search}
              onChange={handleSearch}
              placeholder="Search by name, email..."
            />
          </div>

          {/* Table */}
          <div className="bg-white shadow rounded-2xl overflow-hidden mt-2">
            <table className="w-full">
              <thead className="bg-gray-200 text-m text-black">
                <tr>
                  <th className="p-4 text-left font-normal">S.No</th>
                  <th className="p-4 text-left font-normal">Name</th>
                  <th className="p-4 text-left font-normal">Email</th>
                  <th className="p-4 text-left font-normal">Member Since</th>
                  <th className="p-4 text-left font-normal">Total Events Attended</th>
                  <th className="p-4 text-centre font-normal">Actions</th>
                </tr>
              </thead>

              <tbody>
                {attendeeData.map((host, index) => (
                  <tr key={host._id} className="border-t">
                    <td className="p-4 text-left text-[#4C4C4C] text-sm">
                      {String(startingIndex + index + 1).padStart(2, "0")}
                    </td>

                    <td className="p-4 flex items-center gap-2 text-[#4C4C4C] text-sm">
                      <Avatar name={host.name} image={host.image} />
                      {capitalizeEachWord(host.name)}
                    </td>

                    <td className="p-4 text-left text-[#4C4C4C] text-sm">
                      {host.email}
                    </td>

                    <td className="p-4 text-left text-[#4C4C4C] text-sm">
                      {formatDateTime(host.createdAt) || "--"}
                    </td>

                    <td className="p-4 text-left text-[#4C4C4C] text-sm">
                      {String(host.attendedEventCount || 0).padStart(2, "0")}
                    </td>

                    <td className="p-4 text-center align-middle">
                      <button
                        onClick={() => handleStatus(host._id, host.status)}
                        className={`relative inline-block w-8 h-4 rounded-full transition ${
                          host.status ? "bg-green-500" : "bg-gray-300"
                        }`}
                      >
                        <span
                          className={`absolute top-0.5 left-0.5 w-3 h-3 bg-white rounded-full transition ${
                            host.status ? "translate-x-4" : ""
                          }`}
                        ></span>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {attendeeData.length === 0 && (
              <p className="text-center py-10 text-gray-500">
                No results found
              </p>
            )}
          </div>
          {
            pagination.totalPages > 1 && (
              <Pagination
              page={page}
              totalPages={pagination.totalPages}
              totalItems={pagination.totalUser}
              limit={limit}
              onPageChange={(newPage) => handlePagination(newPage)}
              />
            )
          }
        </div>
      </div>
    </>
  );
};

export default Attendees;
